import {
  EvaluationResultDto,
  GetKycStatusResponseDto,
  FeatureFlagVariantsDto,
  PaymentMethodSettingsResponseDto,
} from '@tiendanube/common';
import { cirrusApi } from 'App/rtk';
import {
  NUVEM_PAGO_FEATURE_FLAG_URL,
  NUVEM_PAGO_FEATURE_FLAG_VARIANT_URL,
  KYC_STATUS_URL,
  EVALUATION_RESULT_URL,
  PAYMENT_SETTING_URL,
} from './urls';

const NuvemPagoCommonsEndpoints = {
  getKycStatus: 'getKycStatus',
  nuvemPagoFeatureFlag: 'nuvemPagoFeatureFlag',
  getFeatureFlagVariant: 'getFeatureFlagVariant',
  evaluationResult: 'evaluationResult',
  getPaymentMethodsSettings: 'getPaymentMethodsSettings',
} as const;

export const nuvemPagoCommonsApi = cirrusApi.injectEndpoints({
  endpoints: (builder) => ({
    [NuvemPagoCommonsEndpoints.getKycStatus]: builder.query<
      GetKycStatusResponseDto,
      void
    >({
      query: () => ({
        method: 'GET',
        url: KYC_STATUS_URL,
      }),
      keepUnusedDataFor: 300,
    }),
    [NuvemPagoCommonsEndpoints.nuvemPagoFeatureFlag]: builder.query<
      boolean,
      string
    >({
      query: (featureFlag: string) => ({
        method: 'GET',
        url: NUVEM_PAGO_FEATURE_FLAG_URL.replace(':flag', featureFlag),
      }),
      keepUnusedDataFor: 60,
    }),
    [NuvemPagoCommonsEndpoints.getFeatureFlagVariant]: builder.query<
      FeatureFlagVariantsDto,
      string
    >({
      query: (featureFlag: string) => ({
        method: 'GET',
        url: NUVEM_PAGO_FEATURE_FLAG_VARIANT_URL.replace(':flag', featureFlag),
      }),
      keepUnusedDataFor: 60,
    }),
    [NuvemPagoCommonsEndpoints.evaluationResult]: builder.query<
      EvaluationResultDto,
      string
    >({
      query: (featureFlag: string) => ({
        method: 'GET',
        url: EVALUATION_RESULT_URL.replace(':flag', featureFlag),
      }),
    }),
    [NuvemPagoCommonsEndpoints.getPaymentMethodsSettings]: builder.query<
      PaymentMethodSettingsResponseDto,
      void
    >({
      query: () => ({
        method: 'GET',
        url: PAYMENT_SETTING_URL,
      }),
    }),
  }),
});

export const {
  useGetKycStatusQuery,
  useNuvemPagoFeatureFlagQuery,
  useGetFeatureFlagVariantQuery,
  useEvaluationResultQuery,
  useGetPaymentMethodsSettingsQuery,
} = nuvemPagoCommonsApi;
